import { TestPlugin as TestPluginAbstractClass } from '@sourceacademy/web-test';
export class TestPlugin extends TestPluginAbstractClass {}
